import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import {organisationDetails, saveOrUpdateOrganisationDetails, exportReport} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import MuiTable from "../common/MuiTable";
import {compareStrings} from "../../util/CommonUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

function createData(name, description, immutable) {
    return { name, description, immutable };
}

const aaaRows = [
    createData('CA', "Corrective Action", true),
    createData('EPA', "Environment Protection Authority", true),
    createData('ERP', "Emergency Response Plan", true),
    createData('IMS', "Integrated Management System", true),
    createData('NCR', "Non Conformance Report", true),
];

const muiColumns2 = [
    { title: 'Acronym', field: 'name'},
    { title: 'Abbreviation', field: 'description' },
];

class AcronymsAndAbbreviations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            acronymsAndAbbreviations: [],
            isLoading: true,
        };

        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                let merged = response.acronymsAndAbbreviations.concat(aaaRows).sort(function(a, b) {
                    return compareStrings(a.name, b.name);
                });
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    acronymsAndAbbreviations: merged,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '' && newData.description && newData.description !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Name and Description are required fields', 5000);
        }
        return isValid;
    }


    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.acronymsAndAbbreviations.length; i < l; i++) {
            if (this.state.organisation.acronymsAndAbbreviations[i].id === toUpdate.id) {
                this.state.organisation.acronymsAndAbbreviations[i].name = toUpdate.name;
                this.state.organisation.acronymsAndAbbreviations[i].description = toUpdate.description;
            }
        }
        console.log("After update:", this.state.organisation.acronymsAndAbbreviations);
        this.handleSubmit(this.state.organisation.acronymsAndAbbreviations);
    }

    handleDelete(toDelete) {
        let acronymsAndAbbreviations = [];
        const index = this.state.organisation.acronymsAndAbbreviations.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.acronymsAndAbbreviations.length; i < l; i++) {
            if (i !== index) {
                acronymsAndAbbreviations.push(this.state.organisation.acronymsAndAbbreviations[i]);
            }
        }
        console.log("After removal:", acronymsAndAbbreviations);
        this.handleSubmit(acronymsAndAbbreviations);
    }

    handleAdd(data) {
        this.state.organisation.acronymsAndAbbreviations.push(data);
        this.handleSubmit(this.state.organisation.acronymsAndAbbreviations);
    }

    handleSubmit(data) {
        this.state.organisation.acronymsAndAbbreviations = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success('Success', 'The Acronyms and Abbreviations have been updated.', 5000);
                this.loadOrganisationDetails();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    render() {
        let { isLoading } = this.state;
        if (isLoading) {
            return null;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5" style={{ marginTop: '30px' }}>
                ACRONYMS AND ABBREVIATIONS
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <MuiTable
                    title="Acronyms and Abbreviations"
                    columns={muiColumns2}
                    data={this.state.acronymsAndAbbreviations}
                    onAdd={this.handleAdd}
                    onUpdate={this.handleUpdate}
                    onDelete={this.handleDelete}
                    isValid={this.isValid}
                    exportButton={!isDemo}
                    onExport={() => exportReport('/organisation/export/ACRONYMS_AND_ABBREVIATIONS')}
                    pageSize={10}
                    allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                />
            </Paper>
            <NotificationContainer/>
        </div>
        ;
    }
}

export default withStyles(classes)(AcronymsAndAbbreviations);